export function AddTile({ onPick, tileRef, position, ready }) {
  const style = {
    position: "absolute",
    left: position?.x ?? 0,
    top: position?.y ?? 0,
    visibility: ready ? "visible" : "hidden",
    transition: "left 200ms ease, top 200ms ease",
  };
  return (
    <button
      ref={tileRef}
      type="button"
      onClick={onPick}
      aria-label="Add file"
      style={style}
      className="w-[140px] h-[140px] rounded-2xl border-2 border-dashed border-zinc-300 dark:border-zinc-700 hover:border-zinc-400 dark:hover:border-zinc-500 hover:bg-zinc-50/40 dark:hover:bg-zinc-800/40 transition-colors flex items-center justify-center text-zinc-300 dark:text-zinc-600 hover:text-zinc-500 dark:hover:text-zinc-400 cursor-pointer"
    >
      <span className="text-2xl font-light leading-none select-none">+</span>
    </button>
  );
}
